import { render, staticRenderFns } from "./finNews_Boerse.vue?vue&type=template&id=49e3f225&scoped=true&"
import script from "./finNews_Boerse.vue?vue&type=script&lang=js&"
export * from "./finNews_Boerse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3f225",
  null
  
)

export default component.exports